import variables from "@/config/variables";
import { TabbedCard } from "@ucl/library";
import { BoltDocumentTemplateGrid } from "@bolt/documenttemplates";
import { BoltTaskRuleGrid, BoltTaskTemplateGrid } from "@bolt/task";
import { useAuthHeadersRequired } from "../lib/auth/authUtils";
import "./BankerAdminPage.scss";
import { EntityTypeOptions, EntityTypes } from "@/constants/entityTypes";

export const BankerAdminPage: React.FC = () => {
  const getAuthRequestHeader = useAuthHeadersRequired();

  return (
    <section className="banker-admin-page">
      <div className="banker-page__header">
        <h1 className="banker-page__title">Admin</h1>
        <p className="banker-page__subtitle">Manage administrative tasks</p>
      </div>
      <div className="banker-admin-page__content">
        <TabbedCard
          tabs={[
            {
              tabKey: "document-templates",
              headerContent: "Document Templates Grid",
              tabContent: (
                <div className="banker-admin-page__tab-content">
                  <BoltDocumentTemplateGrid
                    gridKey="bolt-document-templates-grid"
                    getAuthRequestHeader={getAuthRequestHeader}
                    modelName={"FinancialApplicationExpressionSchema"}
                    entityType={EntityTypes.FinancialApplication.EntityType}
                    previewBaseODataUrl={`${variables.apiBaseUrl}/odata`}
                    previewODataKey="financialapplicationsodata/options"
                    zoomValue={150}
                    annotationDefaults={{
                      fontSize: 8,
                    }}
                  />
                </div>
              ),
            },
            {
              tabKey: "task-templates",
              headerContent: "Task Templates",
              tabContent: (
                <div className="banker-admin-page__tab-content">
                  <BoltTaskTemplateGrid
                    apiBaseUrl={variables.apiBaseUrl}
                    gridKey="banker-task-template-grid"
                    getAuthRequestHeader={getAuthRequestHeader}
                    entityTypeOptions={EntityTypeOptions}
                  />
                </div>
              ),
            },
            {
              tabKey: "task-rules",
              headerContent: "Task Rules",
              tabContent: (
                <div className="banker-admin-page__tab-content">
                  <BoltTaskRuleGrid
                    apiBaseUrl={variables.apiBaseUrl}
                    gridKey="banker-task-rule-grid"
                    getAuthRequestHeader={getAuthRequestHeader}
                  />
                </div>
              ),
            },
          ]}
          className="banker-admin-page__tabbed-card"
          basePath={"/banker/admin"}
        />
      </div>
    </section>
  );
};
